import { render, staticRenderFns } from "./VersionDescription.vue?vue&type=template&id=51687e21&scoped=true"
import script from "./VersionDescription.vue?vue&type=script&lang=js"
export * from "./VersionDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51687e21",
  null
  
)

export default component.exports